import { Fragment } from 'react'
import { connect } from 'react-redux'

import ConversationListHeader from 'components/ConversationList/Header'
import TitleBar from './TitleBar'

// Leaving this as connected component as we'll need to implement search
// in the near future
const select = () => {
  return {
    SearchComponent: null,
    TitleBarComponent: TitleBar,
    FilterBarComponent: Fragment,
  }
}

export default connect(select)(ConversationListHeader)
